import React from 'react';
import { RANGO_HORA } from '../../utils/ordenes';

// Hora de la visita (16-oct-2026): una hora exacta o, si el cliente puede en un rango ("de 9 a 18"),
// desde y hasta. Se guarda en horaEstimada como "10:30" o "09:00-18:00". "Todo el día" = 9 a 18.
const INPUT = 'h-9 px-2 rounded-lg bg-chip text-ink font-bold outline-none';

export default function HoraRango({ value = '', onChange, className = '' }) {
    const v = String(value || '');
    const r = RANGO_HORA.exec(v);
    const desde = r ? r[1].padStart(5, '0') : (/^\d{1,2}:\d{2}/.test(v) ? v.slice(0, 5) : '');
    const hasta = r ? r[2].padStart(5, '0') : '';
    const armar = (d, h) => onChange(d && h ? `${d}-${h}` : (d || ''));
    const todoElDia = desde === '09:00' && hasta === '18:00';
    return (
        <div className={`space-y-1.5 ${className}`}>
            <div className="flex flex-wrap items-center gap-2 text-caption text-secondary">
                <span>{hasta ? 'Desde' : 'Hora exacta (opcional)'}</span>
                <input type="time" value={desde} onChange={e => armar(e.target.value, hasta)} aria-label="Desde" className={INPUT} />
                <span>hasta</span>
                <input type="time" value={hasta} onChange={e => armar(desde || '09:00', e.target.value)} aria-label="Hasta (opcional)" className={INPUT} />
            </div>
            <div className="flex flex-wrap gap-1.5">
                <button type="button" onClick={() => onChange(todoElDia ? '' : '09:00-18:00')}
                    className={`h-8 px-3 rounded-full text-label font-bold border-2 active:scale-95 ${todoElDia ? 'border-brand-red bg-[rgba(232,66,47,0.10)] text-ink' : 'border-transparent bg-chip text-secondary'}`}>
                    Todo el día (9 a 18)
                </button>
                {(desde || hasta) && <button type="button" onClick={() => onChange('')} className="text-caption font-bold text-muted underline">Sin hora</button>}
            </div>
            {hasta && <p className="text-label text-muted">El cliente puede de {desde} a {hasta}: el técnico lo ve así y elige cuándo ir.</p>}
        </div>
    );
}
